/* Rquiere de mixin.js */

var inventoryTemplate = {
	data() {
		return {
			inventoryTemplateSelected: 0,
			listInventoryTemplates: [],
			loadingInventoryTemplates: false,
			methodsInventoryTemplate: {
				get: 'inventoryTemplates',
				show: 'inventoryTemplate/',
				create: 'inventoryTemplate/register',
			},
			paginationInventoryTemplates: [],
			objectInventoryTemplate: {
				exist: 0,
				id: 0,
				name: '',
				inventory_id: 0,
				inventory: {},
				status_id: 0,
				status: {},
				inventory_template_employee: [],
				inventory_template_detail: [],
				inventory_template_store_rack_side_row_column: [],
				inventory_template_store_rack_modules: []
			},
			objectInventoryTemplateStoreRackModuleProductQuantity: {
				exist: 0,
				id: 0,
				inventory_template_store_rack_module_product_id: 0,
				store_rack_module_id: 0,
				store_rack_module: {},
				product_id: 0,
				product: '',
				isbn: '',
				quantity: '',
				employee_id: 0,
				created_at: '',
				updated_at: ''
			},
			searchInventoryTemplate: '',
			objectInventoryTemplateStoreRackPoduleProducts: {
				exist: 0,
				id: 0,
				inventory_template_store_rack_module_id: 0,
				product_id: 0,
				product: {},
				inventory_template_store_rack_module_product_quantitys: [],
				created_at: '',
				updated_at: ''
			},
			qRowsInventoryTemplate: 25,
			savingInventoryTemplate: false,
			savingInventoryTemplateEmployee: false,
			showingInventoryTemplate: false,
			savingInventoryTemplateStoreRackModuleProductQuantity: false
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		addListInventoryTemplates(newInventoryTemplates) {
			this.listInventoryTemplates.push(newInventoryTemplates)
		},
		deleteInventoryTemplateStoreRackModuleProductQuantity(id) {
			let url = this.getApiBackend + 'inventoryTemplateStoreRackModuleProductQuantity/' + id + '/delete'
			this.axiosActionIS(url, 'DELETE', 'deleteInventoryTemplateStoreRackModuleProductQuantityResult')
		},
		deleteInventoryTemplateStoreRackModuleProductQuantityResult(response) {
			this.deleteInventoryTemplateStoreRackModuleProductQuantityResultLocal(response)
		},
		deleteInventoryTemplateStoreRackModuleProductQuantityResultLocal(response) {
			console.log('deleteInventoryTemplateStoreRackModuleProductQuantityResultLocal no desarrollado', response)
		},
		changeQRowsInventoryTemplate() {
			localStorage.setItem('qRowsInventoryTemplate', this.qRowsInventoryTemplate)
			this.getAllInventoryTemplates()
		},
		clearObjectInventoryTemplate() {
			this.objectInventoryTemplate.exist = 0
			this.objectInventoryTemplate.id = 0
			this.objectInventoryTemplate.name = ''
			this.objectInventoryTemplate.inventory_id = 0
			this.objectInventoryTemplate.inventory = {}
			this.objectInventoryTemplate.status_id = 0
			this.objectInventoryTemplate.status = {}
			this.objectInventoryTemplate.inventory_template_employee = []
			this.objectInventoryTemplate.inventory_template_detail = []
			this.objectInventoryTemplate.inventory_template_store_rack_side_row_column = []
			this.objectInventoryTemplate.inventory_template_store_rack_modules = []
		},
		clearObjectInventoryTemplateStoreRackPoduleProducts() {
			this.objectInventoryTemplateStoreRackPoduleProducts.exist = 0
			this.objectInventoryTemplateStoreRackPoduleProducts.id = 0
			this.objectInventoryTemplateStoreRackPoduleProducts.inventory_template_store_rack_module_id = 0
			this.objectInventoryTemplateStoreRackPoduleProducts.product_id = 0
			this.objectInventoryTemplateStoreRackPoduleProducts.product = {}
		},
		getAllInventoryTemplates(page = 1, full = 0) {
			this.loadingInventoryTemplates = true
			this.listInventoryTemplates = []
			this.paginationInventoryTemplates = []
			let parameters = '?search=' + this.searchInventoryTemplates + '&page=' + page + '&full=' + full
			let url = this.getApiBackend + this.methodsInventoryTemplate.get + parameters
			this.axiosActionIS(url, 'GET', 'getAllInventoryTemplatesResult')
		},
		getAllInventoryTemplatesResult(response) {
			this.loadingInventoryTemplates = false
			if (response.data.success == true) {
				this.listInventoryTemplates = response.data.data
				this.paginationInventoryTemplates = response.data.paginate
			}
			this.getAllInventoryTemplatesResultLocal(response)
		},
		getAllInventoryTemplatesResultLocal(response) {
			console.log('getAllInventoryTemplatesResultLocal no desarrollado', response)
		},
		getInventoryTemplatesForYear(inventoryId) {
			this.loadingInventoryTemplates = true
			let url = this.getApiBackend + 'inventory/' + inventoryId + '/templates'
			this.axiosActionIS(url, 'GET', 'getAllInventoryTemplatesResult')
		},
		getInventoryTemplatesEmployee(employeeId, inventoryId = 1, page = 1, full = 0,) {
			this.loadingInventoryTemplates = true
			this.listInventoryTemplates = []
			this.paginationInventoryTemplates = []
			let parameters = '?search=' + this.searchInventoryTemplates + '&page=' + page + '&full=' + full + '&inventoryId=' + inventoryId
			let url = this.getApiBackend + this.methodsInventoryTemplate.get + '/employee/' + employeeId + parameters
			this.axiosActionIS(url, 'GET', 'getInventoryTemplatesEmployeeResult')
		},
		getInventoryTemplatesEmployeeResult(response) {
			this.loadingInventoryTemplates = false
			if (response.data.success == true) {
				this.listInventoryTemplates = response.data.data
				this.paginationInventoryTemplates = response.data.paginate
			}
			this.getInventoryTemplatesEmployeeResultLocal(response)
		},
		getInventoryTemplatesEmployeeResultLocal(response) {
			console.log('getInventoryTemplatesEmployeeResultLocal no desarrollado', response)
		},
		saveInventoryTemplate_old(item) {
			this.savingInventoryTemplate = true
			let method = (item.exist == 0) ? 'POST' : 'PUT'
			let url = this.getApiBackend + this.methodsInventoryTemplate.create
			/*if(method == 'POST') {
				this.axiosActionIS(url, method, 'saveInventoryTemplateResult', item)
			} else {
				//this.axiosActionIS(this.getApiBackend + this.methodsTeam.show + this.objectTeam.id, method, 'saveTeamResult', this.objectTeam)
			}*/
		},
		saveInventoryTemplate() {
			this.savingInventoryTemplate = true
			let url = this.getApiBackend + this.methodsInventoryTemplate.create
			this.axiosActionIS(url, 'POST', 'saveInventoryTemplateResult', this.objectInventoryTemplate)
			/*if(method == 'POST') {
				this.axiosActionIS(url, method, 'saveInventoryTemplateResult', item)
			} else {
				//this.axiosActionIS(this.getApiBackend + this.methodsTeam.show + this.objectTeam.id, method, 'saveTeamResult', this.objectTeam)
			}*/
		},
		saveInventoryTemplateResult(response) {
			this.savingInventoryTemplate = false
			if (response.data.success == true) {
				this.addListInventoryTemplates(response.data.data)
			}
			this.saveInventoryTemplateResultLocal(response)
		},
		saveInventoryTemplateResultLocal(response) {
			console.log('saveInventoryTemplateResult no desarrollado', response)
		},
		setObjectInventoryTemplate(item) {
			this.clearObjectInventoryTemplate()
			let newItem = Object.create(item)
			for (const property in newItem) {
				this.objectInventoryTemplate[property] = newItem[property]
			}
		},
		saveInventoryTemplateEmployee(id, data) {
			this.savingInventoryTemplateEmployee = true
			let method = (data.exist == 0) ? 'POST' : 'PUT'
			let url = this.getApiBackend + this.methodsInventoryTemplate.show + id + '/employee/register'
			if (method == 'POST') {
				this.axiosActionIS(url, method, 'saveInventoryTemplateEmployeeResult', data)
			} else {
				//this.axiosActionIS(this.getApiBackend + this.methodsTeam.show + this.objectTeam.id, method, 'saveTeamResult', this.objectTeam)
			}
		},
		saveInventoryTemplateEmployeeResult(response) {
			this.savingInventoryTemplateEmployee = false
			this.saveInventoryTemplateEmployeeResultLocal(response)
		},
		saveInventoryTemplateEmployeeResultLocal(response) {
			console.log('saveInventoryTemplateEmployeeResultLocal no desarrollado', response)
		},
		saveInventoryTemplateStoreRackModuleProducts(data) {
			let method = 'POST'
			let url = this.getApiBackend + 'inventoryTemplateStoreRackModuleProduct/register'
			this.axiosActionIS(url, method, 'saveInventoryTemplateStoreRackModuleProductsResult', data)
		},
		saveInventoryTemplateStoreRackModuleProductsResult(response) {
			this.saveInventoryTemplateStoreRackModuleProductsResultLocal(response)
		},
		saveInventoryTemplateStoreRackModuleProductsResultLocal(response) {
			console.log('saveInventoryTemplateStoreRackModuleProductsResultLocal no desarrollado', response)
		},
		saveInventoryTemplateStoreRackModuleProductQuantity(data) {
			this.savingInventoryTemplateStoreRackModuleProductQuantity = true
			let method = (data.exist == 0) ? 'POST' : 'PUT'
			let url = this.getApiBackend + 'inventoryTemplateStoreRackModuleProductQuantity/register'
			if (method == 'POST') {
				this.axiosActionIS(url, method, 'saveInventoryTemplateStoreRackModuleProductQuantityResult', data)
			} else {
				url = this.getApiBackend + 'inventoryTemplateStoreRackModuleProductQuantity/' + data.id
				this.axiosActionIS(url, method, 'saveInventoryTemplateStoreRackModuleProductQuantityResult', data)
			}
		},
		saveInventoryTemplateStoreRackModuleProductQuantityResult(response) {
			this.savingInventoryTemplateStoreRackModuleProductQuantity = false
			this.saveInventoryTemplateStoreRackModuleProductQuantityResultLocal(response)
		},
		saveInventoryTemplateStoreRackModuleProductQuantityResultLocal(response) {
			console.log('saveInventoryTemplateStoreRackModuleProductQuantityResult no desarrollado', response)
		},
		showInventoryTemplate(id, withDetails = 0) {
			this.showingInventoryTemplate = true
			this.clearObjectInventoryTemplate()
			let param = '?withDetails=' + withDetails
			let url = this.getApiBackend + this.methodsInventoryTemplate.show + id + param
			this.axiosActionIS(url, 'GET', 'showInventoryTemplateResult')
		},
		showInventoryTemplateResult(response) {
			this.showingInventoryTemplate = false
			if (response.data.success == true) {
				this.setObjectInventoryTemplate(response.data.data)
			}
			this.showInventoryTemplateResultLocal(response)
		},
		showInventoryTemplateResultLocal(response) {
			console.log('showInventoryTemplateResultLocal no desarrollado', response)
		},
		showInventoryTemplateEmployee(id, employeeId) {
			this.showingInventoryTemplate = true
			this.clearObjectInventoryTemplate()
			let url = this.getApiBackend + this.methodsInventoryTemplate.show + id + '/employee/' + employeeId
			this.axiosActionIS(url, 'GET', 'showInventoryTemplateEmployeeResult')
		},
		showInventoryTemplateEmployeeResult(response) {
			this.showingInventoryTemplate = false
			this.showInventoryTemplateEmployeeResultLocal(response)
		},
		showInventoryTemplateEmployeeResultLocal(response) {
			console.log('showInventoryTemplateResult no desarrollado', response)
		},
	},
};

export default inventoryTemplate;